import { useRect } from '@darkroom.engineering/hamo';
import { useEffect, useRef, useState } from 'react';
import { useIntersection } from 'react-use';

const easeOutQuad = (t) => t * (2 - t);
const frameDuration = 1000 / 60;

const CountUp = ({ number, duration = 1000 }) => {
  const el = useRef(null);
  const [rectRef] = useRect();
  const countTo = parseInt(number, 10);
  const [count, setCount] = useState(0);
  const [intersected, setIntersected] = useState(false);
  const intersection = useIntersection(el, {
    rootMargin: '0px',
    threshold: 0,
  });

  useEffect(() => {
    if (intersection?.isIntersecting) {
      setIntersected(true);
    }
  }, [intersection]);

  useEffect(() => {
    if (intersected) {
      let frame = 0;
      const totalFrames = Math.round(duration / frameDuration);
      const counter = setInterval(() => {
        // eslint-disable-next-line no-plusplus
        frame++;
        const progress = easeOutQuad(frame / totalFrames);
        setCount(countTo * progress);

        if (frame === totalFrames) {
          clearInterval(counter);
        }
      }, frameDuration);
    }
  }, [intersected]);

  return (
    <span
      ref={(node) => {
        el.current = node;
        rectRef(node);
      }}
    >
      {Math.floor(count)}
    </span>
  );
};

export default CountUp;
